<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper" :style="{'vertical-align': vAlign}">
                <slot ref="modalOccupant"></slot>
            </div>
        </div>
    </transition>
</template>

<script>

export default{
    name: 'mainModal',
    data: function(){
        return {
            vAlign: this.$route.path == '/extension' ? 'top' : 'middle'
        }
    },

    mounted: function(){
        document.getElementById('rightBar').style['z-index'] = 50
    }
}
</script>